import { render, staticRenderFns } from "./HighSchoolDiplomaForm.vue?vue&type=template&id=18b0fc28&"
import script from "./HighSchoolDiplomaForm.vue?vue&type=script&lang=js&"
export * from "./HighSchoolDiplomaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports